// @/components/DashboardLoader/useDashboardLoader.ts
import { useState } from "react";

export interface LoadEvent {
  id: string;
  label: string;
  done: boolean;
}

export function useDashboardLoader(initialEvents: LoadEvent[]) {
  const [events, setEvents] = useState<LoadEvent[]>(initialEvents);
  const [visible, setVisible] = useState(true);

  function markDone(id: string) {
    setEvents((prev) =>
      prev.map((e) =>
        e.id === id ? { ...e, done: true } : e
      )
    );
  }

  function hide() {
    setVisible(false);
  }

  const allDone = events.every((e) => e.done);

  return {
    events,
    visible,
    allDone,
    markDone,
    hide,
  };
}